import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToggle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconToggle"><Path fillRule="evenodd" clipRule="evenodd" d="M23.5 12C23.5 16.4183 19.9183 20 15.5 20H8.5C4.08172 20 0.5 16.4183 0.5 12C0.5 7.58172 4.08172 4 8.5 4H15.5C19.9183 4 23.5 7.58172 23.5 12ZM15.5 15C17.1569 15 18.5 13.6569 18.5 12C18.5 10.3431 17.1569 9 15.5 9C13.8431 9 12.5 10.3431 12.5 12C12.5 13.6569 13.8431 15 15.5 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToggle;
